import { __extends } from "tslib";
import { Gesture } from './gesture';
var Pan = /** @class */ (function (_super) {
    __extends(Pan, _super);
    function Pan() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.EVENT = 'pan';
        return _this;
    }
    Pan.prototype.onTouchCancel = function (ev) { };
    Pan.prototype.onTouchEnd = function (ev) { };
    Pan.prototype.onTouchMove = function (ev) {
        var x = ev.x, y = ev.y;
        var deltaX = x - this.preX;
        var deltaY = y - this.preY;
        this.preX = x;
        this.preY = y;
        this.emit({ x: x, y: y, deltaX: deltaX, deltaY: deltaY, event: ev });
    };
    Pan.prototype.onTouchStart = function (ev) {
        var x = ev.x, y = ev.y;
        this.preX = x;
        this.preY = y;
    };
    return Pan;
}(Gesture));
export { Pan };
//# sourceMappingURL=pan.js.map